<mat-sidenav-container>
  <mat-sidenav
    mode="over"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="60"
    [opened]="propertyFilterState.isFilterSheetOpen$ | async"
    (closed)="propertyFilterState.isFilterSheetOpen = false; showDropdown.lPrice = false; showDropdown.hPrice = false"
  >
    <div class="sliding-sheet-header">
      <h4>All Filters</h4>
      <button type="button" (click)="propertyFilterService.toggleFilterSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="filter-sheet-body" [formGroup]="filterForm" #scrollableContainer>
      <div class="d-flex justify-content-center my-4">
        <mat-button-toggle-group class="tab-grp" [formControl]="statusToggleBtnCtrl">
          <mat-button-toggle value="forSale">For Sale</mat-button-toggle>
          <mat-button-toggle value="sold">Sold</mat-button-toggle>
          <mat-button-toggle value="rental" *ngIf="appState?.companyInfoValue?.alias != 'opscan'"
            >Rental</mat-button-toggle
          >
        </mat-button-toggle-group>
      </div>

      <mat-accordion [multi]="true">
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title> Applied Filters </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-chip-list class="example-chip" cdkDropList cdkDropListOrientation="horizontal">
            <mat-chip class="applied-filter" color="primary" *ngFor="let filter of selectedFilters">
              {{ filter.key }} <span *ngIf="filter.value"> : </span> <b class="pl-1">{{ filter.value }}</b>
            </mat-chip>
          </mat-chip-list>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" *ngIf="statusToggleBtnCtrl.value != 'rental'">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span *ngIf="statusToggleBtnCtrl.value == 'forSale'"> Listing Type </span>
              <span *ngIf="statusToggleBtnCtrl.value == 'sold'"> Sold Within </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="filter-group-container" *ngIf="statusToggleBtnCtrl.value == 'forSale'">
            <div class="row">
              <div class="col-md-4 col-12">
                <div class="d-inline-block">
                  <mat-icon
                    role="img"
                    matprefix=""
                    inline=""
                    class="legend-icon listing mr-2 pt-1"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >circle</mat-icon
                  >
                  <mat-checkbox formControlName="isForSale" color="primary"> For Sale on MLS (Standard) </mat-checkbox>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4 col-12 mb-2">
                <div class="row">
                  <div class="col-md-12 col-12">
                    <div class="d-inline-block">
                      <mat-icon
                        role="img"
                        matprefix=""
                        inline=""
                        class="legend-icon distressed mr-2 pt-1"
                        aria-hidden="true"
                        data-mat-icon-type="font"
                        >circle</mat-icon
                      >
                      <mat-checkbox
                        color="primary"
                        [disabled]="getForeclosureDisableStatus()"
                        [checked]="isChecked()"
                        [indeterminate]="isAllSelected()"
                        (change)="selectAll($event)"
                        class="pb-2"
                      >
                        Foreclosure
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-12">
                    <mat-checkbox
                      color="primary"
                      formControlName="isPreFcl"
                      class="pl-5 pb-2"
                      (change)="updateDistressStatus($event)"
                    >
                      Pre-Foreclosure
                    </mat-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-12">
                    <mat-checkbox
                      color="primary"
                      formControlName="isAuction"
                      (change)="updateDistressStatus($event)"
                      class="pl-5 pb-2"
                    >
                      Auction
                    </mat-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-12">
                    <mat-checkbox
                      color="primary"
                      formControlName="isReo"
                      class="pl-5 pb-2"
                      (change)="updateDistressStatus($event)"
                    >
                      REO / Bank Owned
                    </mat-checkbox>
                  </div>
                </div>
              </div>
              <span *ngIf="getForeclosureDisableStatus()" class="d-block mb-2 text-muted"
                >Foreclosure and Hud listings are not enabled for the selected plan</span
              >
              <div class="col-md-4 col-12 mb-2">
                <div class="row">
                  <div class="col-md-12 col-12">
                    <div class="d-flex">
                      <mat-icon
                        role="img"
                        matprefix=""
                        inline=""
                        class="legend-icon hud mr-2 pt-1"
                        aria-hidden="true"
                        data-mat-icon-type="font"
                        >circle</mat-icon
                      >
                      <mat-checkbox color="primary" formControlName="isHud" (change)="updateDistressStatus($event)">
                        Hud
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12 mb-2">
                <div class="row">
                  <div class="col-md-12 col-12">
                    <mat-slide-toggle color="primary" formControlName="includePending"
                      >Include Pending</mat-slide-toggle
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-group-container" *ngIf="statusToggleBtnCtrl.value == 'sold'">
            <!-- <button class="mat-menu-item filter-item-container">
              <mat-checkbox formControlName="soldWithin" color="primary"> Sold Within </mat-checkbox>
            </button> -->
            <div class="row">
              <mat-form-field class="col-lg-4 col-12">
                <div class="d-flex">
                  <mat-icon
                    role="img"
                    matprefix=""
                    inline=""
                    class="legend-icon sold mr-2"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    >circle</mat-icon
                  >
                  <!-- <mat-select [(ngModel)]="propertySoldWithin"> -->
                  <mat-select formControlName="soldWithin">
                    <mat-option
                      *ngFor="let option of PropertyFilterConfig.soldWithinOptions"
                      [value]="option.value"
                      (onSelectionChange)="soldValueChanges()"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                </div>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title> Price </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="filter-group-container">
            <div class="row mb-5">
              <div class="col-md-3 col-6">
                <mat-form-field class="w-100">
                  <div class="dropdown-container">
                    <div class="input-wrapper">
                      <input
                        matInput
                        type="text"
                        placeholder="Min Price"
                        formControlName="lPrice"
                        (input)="onType($event, 'lPrice')"
                        mask="separator.2"
                        prefix="$"
                        class="small-form-field"
                        autocomplete="off"
                      />
                      <span class="dropdown-icon" (click)="toggleDropdown('lPrice')"> ▼ </span>
                    </div>
                    <ul *ngIf="showDropdown.lPrice" class="dropdown">
                      <li
                        *ngFor="
                          let item of statusToggleBtnCtrl.value === 'rental'
                            ? PropertyFilterConfig.minRentalPriceList
                            : PropertyFilterConfig.minPriceList
                        "
                        (click)="selectPrice(item, 'lPrice')"
                      >
                        {{ item.label }}
                      </li>
                    </ul>
                  </div>
                </mat-form-field>
              </div>
              <div class="col-md-3 col-6">
                <mat-form-field class="w-100">
                  <mat-label> Max Price</mat-label>
                  <div class="input-wrapper">
                    <input
                      matInput
                      type="text"
                      id="inputField"
                      formControlName="hPrice"
                      mask="separator.2"
                      class="small-form-field"
                      prefix="$"
                      (input)="onType($event, 'hPrice')"
                      autocomplete="off"
                    />
                    <span class="dropdown-icon" (click)="toggleDropdown('hPrice')"> ▼ </span>
                  </div>
                  <ul *ngIf="showDropdown.hPrice" class="dropdown">
                    <li
                      *ngFor="
                        let item of statusToggleBtnCtrl.value === 'rental'
                          ? PropertyFilterConfig.maxRentalPriceList
                          : PropertyFilterConfig.maxPriceList
                      "
                      (click)="selectPrice(item, 'hPrice')"
                    >
                      {{ item.label }}
                    </li>
                  </ul>
                </mat-form-field>
              </div>
            </div>
          </div>
          <mat-error
            *ngIf="filterForm.get('lPrice').hasError('minMaxError') || filterForm.get('hPrice').hasError('minMaxError')"
            class="text-danger"
          >
            Min value should not be greater than max value
          </mat-error>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title> Bed & Bath </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="filter-group-container">
            <mat-label class="mt-3 mb-2">Bedrooms</mat-label>
            <section class="mt-2">
              <div class="row lt-40">
                <div class="col-md-4 col-12">
                  <mat-button-toggle-group
                    class="small-form-field"
                    [formControl]="bedToggleBtnCtrl"
                    color="secondary"
                    style="vertical-align: text-top"
                  >
                    <mat-button-toggle [value]="null"> Any </mat-button-toggle>
                    <mat-button-toggle
                      *ngFor="let value of PropertyFilterConfig.bedBathToggleValues"
                      [value]="value.value"
                    >
                      {{ value.label }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <div class="col-md-1 col-12">
                  <span class="or-seperator">OR</span>
                </div>
                <div class="col-md-2 col-4">
                  <mat-form-field class="small-form-field w-100 mt-5p">
                    <mat-label>Min</mat-label>
                    <mat-select formControlName="lBed">
                      <mat-option *ngFor="let value of PropertyFilterConfig.bedBathDropdownValues" [value]="value">
                        {{ value }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-2 col-4">
                  <mat-form-field class="small-form-field w-100 mt-5p">
                    <mat-label>Max</mat-label>
                    <mat-select formControlName="hBed">
                      <mat-option *ngFor="let value of PropertyFilterConfig.bedBathDropdownValues" [value]="value">
                        {{ value }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <mat-error
                *ngIf="filterForm.get('lBed').hasError('minMaxError') || filterForm.get('hBed').hasError('minMaxError')"
                class="text-danger"
              >
                Min value should not be greater than max value
              </mat-error>
            </section>

            <mat-label class="mt-3 mb-2">Bathrooms</mat-label>
            <section class="mt-2">
              <div class="row lt-40">
                <div class="col-md-4 col-12">
                  <mat-button-toggle-group
                    class="small-form-field"
                    [formControl]="bathToggleBtnCtrl"
                    color="secondary"
                    style="vertical-align: text-top"
                  >
                    <mat-button-toggle [value]="null"> Any </mat-button-toggle>
                    <mat-button-toggle
                      *ngFor="let value of PropertyFilterConfig.bedBathToggleValues"
                      [value]="value.value"
                    >
                      {{ value.label }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <div class="col-md-1 col-12">
                  <span class="or-seperator">OR</span>
                </div>
                <div class="col-md-2 col-4">
                  <mat-form-field class="small-form-field w-100 mt-5p">
                    <mat-label>Min</mat-label>
                    <mat-select formControlName="lBath">
                      <mat-option *ngFor="let value of PropertyFilterConfig.bedBathDropdownValues" [value]="value">
                        {{ value }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-2 col-4">
                  <mat-form-field class="small-form-field w-100 mt-5p">
                    <mat-label>Max</mat-label>
                    <mat-select formControlName="hBath">
                      <mat-option *ngFor="let value of PropertyFilterConfig.bedBathDropdownValues" [value]="value">
                        {{ value }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <mat-error
                *ngIf="
                  filterForm.get('lBath').hasError('minMaxError') || filterForm.get('hBath').hasError('minMaxError')
                "
                class="text-danger"
              >
                Min value should not be greater than max value
              </mat-error>
            </section>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title> Home Type </mat-panel-title>
          </mat-expansion-panel-header>
          <section>
            <div class="row mt-3">
              <div class="home_type_card_wrap col-md-12">
                <div *ngFor="let value of PropertyFilterConfig.HomeTypeArray; let i = index">
                  <div
                    class="cards"
                    (click)="toggleSelection(value)"
                    [ngClass]="{ selected: isSelected(value) }"
                    *ngIf="value['label'] != 'Land' || statusToggleBtnCtrl.value != 'rental'"
                  >
                    <img [src]="'../../assets/images/home-type/' + value['icon']" />
                    <p class="card_title">{{ value['label'] }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Property Features </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="filter-group-container">
            <div class="row mt-3">
              <div class="col-lg-4 mb-2">
                <mat-label>Living Area (sqft.)</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-select formControlName="lLiving" placeholder="Min">
                      <mat-option [value]="null">Any</mat-option>
                      <mat-option
                        *ngFor="let minPrice of PropertyFilterConfig.minLivingAreaOptions"
                        [value]="minPrice['value'].toString()"
                      >
                        {{ minPrice['label'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-select placeholder="Max" formControlName="hLiving">
                      <mat-option [value]="null">Any</mat-option>
                      <mat-option
                        *ngFor="let maxPrice of PropertyFilterConfig.maxLivingAreaOptions"
                        [value]="maxPrice['value'].toString()"
                      >
                        {{ maxPrice['label'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('lLiving').errors?.minMaxError || filterForm.get('hLiving').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 mb-2">
                <mat-label>Lot Size</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-select formControlName="lLot" placeholder="Min">
                      <mat-option [value]="null">Any</mat-option>
                      <mat-option
                        *ngFor="let minPrice of PropertyFilterConfig.minLotSizeOptions"
                        [value]="minPrice['value'].toString()"
                      >
                        {{ minPrice['label'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-select formControlName="hLot" placeholder="Max">
                      <mat-option [value]="null">Any</mat-option>
                      <mat-option
                        *ngFor="let maxPrice of PropertyFilterConfig.maxLotSizeOptions"
                        [value]="maxPrice['value'].toString()"
                      >
                        {{ maxPrice['label'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-12">
                  <mat-error
                    *ngIf="filterForm.get('lLot').errors?.minMaxError || filterForm.get('hLot').errors?.minMaxError"
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-4 mb-2">
                <mat-label class="m-d-none">&nbsp;</mat-label>
                <mat-form-field class="col-lg-12 col-12 px-0">
                  <mat-select placeholder="Parking Space" formControlName="lParking">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let space of PropertyFilterConfig.parkingSpaceOptions"
                      [value]="space['value'].toString()"
                    >
                      {{ space['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 mb-2">
                <mat-label>Year Built </mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="6"
                      matInput
                      type="number"
                      min="1000"
                      placeholder="YYYY"
                      autocomplete="off"
                      formControlName="lYearBuilt"
                      (input)="validateYear($event.target, 'lYearBuilt', 'lYearBuilt', 'hYearBuilt')"
                    />
                  </mat-form-field>
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="7"
                      matInput
                      type="number"
                      min="1000"
                      [max]="currentYear"
                      placeholder="YYYY"
                      autocomplete="off"
                      formControlName="hYearBuilt"
                      (input)="validateYear($event.target, 'hYearBuilt', 'lYearBuilt', 'hYearBuilt')"
                    />
                  </mat-form-field>

                  <mat-error
                    *ngIf="
                      filterForm.get('hYearBuilt')?.errors?.invalidYear ||
                      filterForm.get('lYearBuilt')?.errors?.invalidYear
                    "
                  >
                    Please enter a valid year (1000 - {{ currentYear }})
                  </mat-error>
                  <mat-error *ngIf="invalidYear" class="invalid-feedback"> Enter a valid year </mat-error>
                  <mat-error
                    *ngIf="
                      filterForm.get('hYearBuilt')?.errors?.maxMinYear ||
                      filterForm.get('lYearBuilt')?.errors?.maxMinYear
                    "
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-4 mb-2">
                <mat-label>Stories</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="8"
                      matInput
                      type="number"
                      formControlName="lStories"
                      name="minStories"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="9"
                      matInput
                      type="number"
                      formControlName="hStories"
                      name="maxStories"
                      mask="separator.2"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>
                <div class="col-lg-12">
                  <mat-error
                    *ngIf="
                      filterForm.get('lStories').errors?.minMaxError || filterForm.get('hStories').errors?.minMaxError
                    "
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" *ngIf="authorizeService.canView('mortgages')" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Mortgage </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="filter-group-container">
            <div class="row mt-3">
              <div class="col-lg-4 mb-2">
                <mat-label>Number of Mortgages</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="4"
                      matInput
                      type="text"
                      formControlName="lMortgage"
                      name="minVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>

                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="5"
                      matInput
                      type="text"
                      formControlName="hMortgage"
                      name="maxVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('lMortgage').errors?.minMaxError ||
                        filterForm.get('hMortgage').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 mb-2">
                <mat-label>Estimated Loan Balance</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="4"
                      matInput
                      type="text"
                      formControlName="lLoanBalance"
                      name="minVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="5"
                      matInput
                      type="text"
                      formControlName="hLoanBalance"
                      name="maxVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('lLandValue').errors?.minMaxError ||
                        filterForm.get('hLoanBalance').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 mb-2">
                <mat-label>Total Est. Monthly Payment</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="4"
                      matInput
                      type="text"
                      formControlName="lMonthlyPayment"
                      name="minVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="5"
                      matInput
                      type="text"
                      formControlName="hMonthlyPayment"
                      name="maxVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('lMonthlyPayment').errors?.minMaxError ||
                        filterForm.get('hMonthlyPayment').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 mb-2">
                <mat-label>Current Est. LTV</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Min</mat-label>
                    <input
                      tabindex="4"
                      matInput
                      type="text"
                      formControlName="lLtv"
                      name="minVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                  <mat-form-field class="col-lg-6 col-6">
                    <mat-label>Max</mat-label>
                    <input
                      tabindex="5"
                      matInput
                      type="text"
                      formControlName="hLtv"
                      name="maxVal"
                      autocomplete="off"
                      mask="separator.2"
                    />
                  </mat-form-field>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="filterForm.get('lLtv').errors?.minMaxError || filterForm.get('hLtv').errors?.minMaxError"
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>

            <h6 class="my-4 mortgage-head">First Mortgage</h6>
            <div class="filter-group-container">
              <div class="row">
                <div class="col-lg-4 mb-2">
                  <mat-label>Term</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLTerm"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHTerm"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('mortgLTerm').errors?.minMaxError ||
                        filterForm.get('mortgHTerm').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Rate Type</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-12">
                      <mat-select class="col-lg-12" formControlName="mortgRateType" placeholder="Min">
                        <mat-option [value]="null">Select one</mat-option>
                        <mat-option
                          *ngFor="let rateType of PropertyFilterConfig.MortgageRateType"
                          [value]="rateType['value'].toString()"
                        >
                          {{ rateType['label'] }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Interest Rate</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLRate"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                        suffix=" %"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHRate"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                        suffix=" %"
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('mortgLRate').errors?.minMaxError ||
                        filterForm.get('mortgHRate').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 mb-2">
                  <mat-label>Principal Amount</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLPrincipal"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                        prefix="$"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHPrincipal"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                        prefix="$"
                      />
                    </mat-form-field>
                    <mat-error
                      *ngIf="
                        filterForm.get('mortgLPrincipal').errors?.minMaxError ||
                        filterForm.get('mortgHPrincipal').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Age</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>

                      <input
                        tabindex="4"
                        type="text"
                        matInput
                        [matDatepicker]="mortgLDateToDatePicker"
                        placeholder="Choose a date"
                        [max]="maxDate"
                        formControlName="mortgLDate"
                        (dateChange)="onDateChange($event, 'mortgLDate')"
                      />
                      <mat-datepicker-toggle matSuffix [for]="mortgLDateToDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #mortgLDateToDatePicker></mat-datepicker>
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>

                      <input
                        tabindex="5"
                        type="text"
                        matInput
                        [matDatepicker]="mortageHDatePicker"
                        placeholder="Choose a date"
                        [max]="maxDate"
                        formControlName="mortgHDate"
                        (dateChange)="onDateChange($event, 'mortgHDate')"
                      />
                      <mat-datepicker-toggle matSuffix [for]="mortageHDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #mortageHDatePicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <h6 class="my-4 mortgage-head">Second Mortgage</h6>
            <div class="filter-group-container">
              <div class="row">
                <div class="col-lg-4 mb-2">
                  <mat-label>Term</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLTerm2"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHTerm2"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('mortgLTerm2').errors?.minMaxError ||
                        filterForm.get('mortgHTerm2').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Rate Type</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-12">
                      <mat-select class="col-lg-12" formControlName="mortgRateType2" placeholder="Min">
                        <mat-option [value]="null">Select one</mat-option>
                        <mat-option
                          *ngFor="let rateType of PropertyFilterConfig.MortgageRateType"
                          [value]="rateType['value'].toString()"
                        >
                          {{ rateType['label'] }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Interest Rate</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLRate2"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                        suffix=" %"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHRate2"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                        suffix=" %"
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-12">
                    <mat-error
                      *ngIf="
                        filterForm.get('mortgLRate2').errors?.minMaxError ||
                        filterForm.get('mortgHRate2').errors?.minMaxError
                      "
                      class="text-danger"
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 mb-2">
                  <mat-label>Principal Amount</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>
                      <input
                        tabindex="4"
                        matInput
                        type="text"
                        formControlName="mortgLPrincipal2"
                        name="minVal"
                        autocomplete="off"
                        mask="separator.2"
                        prefix="$"
                      />
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>
                      <input
                        tabindex="5"
                        matInput
                        type="text"
                        formControlName="mortgHPrincipal2"
                        name="maxVal"
                        autocomplete="off"
                        mask="separator.2"
                        prefix="$"
                      />
                    </mat-form-field>
                    <div class="col-lg-12">
                      <mat-error
                        *ngIf="
                          filterForm.get('mortgLPrincipal2').errors?.minMaxError ||
                          filterForm.get('mortgHPrincipal2').errors?.minMaxError
                        "
                        class="text-danger"
                      >
                        Min value should not be greater than max value
                      </mat-error>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 mb-2">
                  <mat-label>Age</mat-label>
                  <div class="row">
                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Min</mat-label>

                      <input
                        tabindex="4"
                        type="text"
                        matInput
                        [matDatepicker]="mortgLDDatePicker"
                        placeholder="Choose a date"
                        [max]="maxDate"
                        formControlName="mortgLDate2"
                        (dateChange)="onDateChange($event, 'mortgLDate2')"
                      />
                      <mat-datepicker-toggle matSuffix [for]="mortgLDDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #mortgLDDatePicker></mat-datepicker>
                    </mat-form-field>
                    <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                    <mat-form-field class="col-lg-6 col-6">
                      <mat-label>Max</mat-label>

                      <input
                        tabindex="5"
                        type="text"
                        matInput
                        [matDatepicker]="mortgHDatePicker"
                        placeholder="Choose a date"
                        [max]="maxDate"
                        formControlName="mortgHDate2"
                        (dateChange)="onDateChange($event, 'mortgHDate2')"
                      />
                      <mat-datepicker-toggle matSuffix [for]="mortgHDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #mortgHDatePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="filterForm.get('mortgHDate').hasError('dateLessThan')">
                      Max date must be greater than Min date.
                    </mat-error>
                  </div>
                  <mat-error *ngIf="filterForm.get('mortgHDate').hasError('dateLessThan')">
                    Max date must be greater than Min date.
                  </mat-error>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title> Ownership </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="filter-group-container">
            <div class="row mt-3">
              <div class="col-lg-4 col-12 mb-2">
                <mat-label>Ownership</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-12">
                    <mat-label>Owner By</mat-label>
                    <mat-select formControlName="corpOwned">
                      <mat-option [value]="null"> Any </mat-option>
                      <mat-option
                        *ngFor="let value of PropertyFilterConfig.OwnerShipDropdownValues"
                        [value]="value.value.toString()"
                      >
                        {{ value.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-12 mb-2">
                <mat-label> Occupancy</mat-label>
                <div class="row">
                  <mat-form-field class="col-lg-12">
                    <mat-label> Occupancy</mat-label>
                    <mat-select formControlName="occupied">
                      <mat-option [value]="null"> Any </mat-option>
                      <mat-option
                        *ngFor="let value of PropertyFilterConfig.OccupancyDropdownValues"
                        [value]="value.value.toString()"
                      >
                        {{ value.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-12 mb-2">
                <mat-label> Ownership Duration </mat-label>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-6">
                    <mat-form-field class="w-100">
                      <mat-label>Min Years</mat-label>
                      <input
                        tabindex="2"
                        formControlName="lOwnDuration"
                        type="number"
                        min="1000"
                        [max]="currentYear"
                        placeholder="YYYY"
                        matInput
                        (input)="validateYear($event.target, 'lOwnDuration', 'lOwnDuration', 'hOwnDuration')"
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-6 col-md-6 col-6">
                    <mat-form-field class="w-100">
                      <mat-label>Max Years</mat-label>
                      <input
                        type="number"
                        tabindex="3"
                        matInput
                        formControlName="hOwnDuration"
                        placeholder="days"
                        (input)="validateYear($event.target, 'hOwnDuration', 'lOwnDuration', 'hOwnDuration')"
                      />
                    </mat-form-field>
                    <mat-error
                      *ngIf="
                        filterForm.get('lOwnDuration')?.errors?.invalidYear ||
                        filterForm.get('hOwnDuration')?.errors?.invalidYear
                      "
                    >
                      Please enter a valid year (1000 - {{ currentYear }})
                    </mat-error>
                    <mat-error
                      *ngIf="
                        filterForm.get('lOwnDuration')?.errors?.maxMinYear ||
                        filterForm.get('hOwnDuration')?.errors?.maxMinYear
                      "
                    >
                      Min value should not be greater than max value
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" *ngIf="statusToggleBtnCtrl.value != 'rental'">
          <mat-expansion-panel-header>
            <mat-panel-title> Tax & Assessment </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row mt-3">
            <div class="col-lg-4 mb-2">
              <mat-label>Annual Tax</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Min</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="lTax"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    formControlName="hTax"
                    name="maxVal"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <div class="col-12">
                  <mat-error
                    *ngIf="filterForm.get('lTax').errors?.minMaxError || filterForm.get('hTax').errors?.minMaxError"
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <mat-label>Total Assessed Value</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Min</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    name="minVal"
                    formControlName="lValue"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    name="maxVal"
                    formControlName="hValue"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <div class="col-12">
                  <mat-error
                    *ngIf="filterForm.get('lValue').errors?.minMaxError || filterForm.get('hValue').errors?.minMaxError"
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 mb-2">
              <mat-label>Assessed Land Value</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Min</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="lLandValue"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    formControlName="hLandValue"
                    name="maxVal"
                    autocomplete="off"
                    prefix="$"
                    mask="separator.2"
                  />
                </mat-form-field>
                <div class="col-lg-12">
                  <mat-error
                    *ngIf="
                      filterForm.get('lLandValue').errors?.minMaxError ||
                      filterForm.get('hLandValue').errors?.minMaxError
                    "
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <mat-label>Assessed Bldg. Value</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Min</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    formControlName="lBldgValue"
                    type="text"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    formControlName="hBldgValue"
                    name="maxVal"
                    autocomplete="off"
                    mask="separator.2"
                    prefix="$"
                  />
                </mat-form-field>
                <div class="col-lg-12">
                  <mat-error
                    *ngIf="
                      filterForm.get('lBldgValue').errors?.minMaxError ||
                      filterForm.get('hBldgValue').errors?.minMaxError
                    "
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" *ngIf="statusToggleBtnCtrl.value != 'rental'">
          <mat-expansion-panel-header>
            <mat-panel-title> Values </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row mt-3">
            <div class="col-lg-4 mb-2">
              <mat-label>Last Sale Price</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-select formControlName="lSalePrice" placeholder="Min">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let minPrice of PropertyFilterConfig.minLastSaleAndEstimatedPriceOptions"
                      [value]="minPrice['value'].toString()"
                    >
                      {{ minPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-lg-6 col-6">
                  <mat-select placeholder="Max" formControlName="hSalePrice">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let maxPrice of PropertyFilterConfig.maxLastSaleAndEstimatedPriceOptions"
                      [value]="maxPrice['value'].toString()"
                    >
                      {{ maxPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-12">
                <mat-error
                  *ngIf="
                    filterForm.get('lSalePrice').errors?.minMaxError || filterForm.get('hSalePrice').errors?.minMaxError
                  "
                  class="text-danger"
                >
                  Min value should not be greater than max value
                </mat-error>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <mat-label>Estimated Value</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-select formControlName="lEstValue" placeholder="Min">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let minPrice of PropertyFilterConfig.minLastSaleAndEstimatedPriceOptions"
                      [value]="minPrice['value'].toString()"
                    >
                      {{ minPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-lg-6 col-6">
                  <mat-select formControlName="hEstValue" placeholder="Max">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let maxPrice of PropertyFilterConfig.minLastSaleAndEstimatedPriceOptions"
                      [value]="maxPrice['value'].toString()"
                    >
                      {{ maxPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="col-lg-12">
                  <mat-error
                    *ngIf="
                      filterForm.get('lEstValue').errors?.minMaxError || filterForm.get('hEstValue').errors?.minMaxError
                    "
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <mat-label class="m-d-none">&nbsp;</mat-label>
              <div class="row" *ngIf="statusToggleBtnCtrl.value == 'forSale'">
                <mat-form-field class="col-lg-12">
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    placeholder="Underpriced by"
                    name="maxVal"
                    autocomplete="off"
                    currencyMask
                    formControlName="underprice"
                    mask="separator.2"
                    suffix=" %"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 mb-2">
              <mat-label>Rent Value</mat-label>
              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-select formControlName="lRent" placeholder="Min">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let minPrice of PropertyFilterConfig.minRentValueOptions"
                      [value]="minPrice['value'].toString()"
                    >
                      {{ minPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="col-lg-6 col-6">
                  <mat-select placeholder="Max" formControlName="hRent">
                    <mat-option [value]="null">Any</mat-option>
                    <mat-option
                      *ngFor="let maxPrice of PropertyFilterConfig.maxRentValueOptions"
                      [value]="maxPrice['value'].toString()"
                    >
                      {{ maxPrice['label'] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="col-lg-12">
                  <mat-error
                    *ngIf="filterForm.get('lRent').errors?.minMaxError || filterForm.get('hRent').errors?.minMaxError"
                    class="text-danger"
                  >
                    Min value should not be greater than max value
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <mat-label>Cap Rate</mat-label>

              <div class="row">
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Min</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    formControlName="lCapRate"
                    type="text"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                  />
                </mat-form-field>
                <mat-form-field class="col-lg-6 col-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    formControlName="hCapRate"
                    name="maxVal"
                    autocomplete="off"
                    mask="separator.2"
                  />
                </mat-form-field>
              </div>
              <span *ngIf="getCapRateDisableStatus()" class="d-block mb-2 text-muted"
                >This filter is not enabled for the selected plan</span
              >
              <div class="col-lg-12">
                <mat-error
                  *ngIf="
                    filterForm.get('lCapRate').errors?.minMaxError || filterForm.get('hCapRate').errors?.minMaxError
                  "
                  class="text-danger"
                >
                  Min value should not be greater than max value
                </mat-error>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" *ngIf="statusToggleBtnCtrl.value == 'forSale'">
          <mat-expansion-panel-header>
            <mat-panel-title> Listing </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row mt-2">
            <div class="col-lg-12">
              <div class="row">
                <mat-form-field class="col-lg-3 mb-2">
                  <mat-label>In the Market for more than</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="lOnMktDays"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    suffix=" days"
                  />
                </mat-form-field>
                <mat-form-field class="col-lg-3 mb-2">
                  <mat-label>Flipped within</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="flipWithin"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    suffix=" days"
                  />
                </mat-form-field>
                <mat-form-field class="col-lg-3 mb-2">
                  <mat-label>Listed within the last</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="hOnMktDays"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    suffix=" days"
                  />
                </mat-form-field>
                <mat-form-field class="col-lg-3 mb-2">
                  <mat-label>Distress Started Within last</mat-label>
                  <input
                    tabindex="4"
                    matInput
                    type="text"
                    formControlName="lDistressStart"
                    name="minVal"
                    autocomplete="off"
                    mask="separator.2"
                    suffix=" days"
                  />
                </mat-form-field>
                <!--  (keyup)="manageInput(index, 'minVal', taxAndAssessmentFilter)"-->

                <!-- <mat-form-field class="col-lg-6">
                  <mat-label>Max</mat-label>
                  <input
                    tabindex="5"
                    matInput
                    type="text"
                    formControlName="hLandValue"
                    name="maxVal"
                    autocomplete="off"
                    currencyMask
                  />
                </mat-form-field> -->
              </div>
            </div>

            <div class="col-lg-4"></div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <footer class="filter-sheet-footer">
      <button mat-button class="mr-2" (click)="_resetFilter()">Reset All</button>
      <button mat-flat-button class="mr-3" color="primary" (click)="_handleFilterAction()">Apply Filter</button>
    </footer>
  </mat-sidenav>
</mat-sidenav-container>
